/*=========================================================================================
  File Name: moduleSettings.js
  Description: Settings Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from './moduleSettingsState'
import mutations from './moduleSettingsMutations.js'
import actions from './moduleSettingsActions.js'
import getters from './moduleSettingsGetters.js'

export default {
	namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
}
